import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    onInput: {type: Boolean, default: true},
    timeout: {type: Number, default: 300}
  }

  initialize() {
    this.submit = this.submit.bind(this);
  }

  connect() {
    if (this.onInputValue) {
      this.element.addEventListener("input", this.submit)
    }
  }

  disconnect() {
    if (this.onInputValue) {
      this.element.removeEventListener("input", this.submit)
    }
  }

  submit() {
    console.log("Auto Submit triggered")
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.element.requestSubmit();
    }, this.timeoutValue); // Adjust the delay as needed
  }
}